Vue.component('part-component', {
  template: `
    <div class="part">
      <div class="box">
      <article class="media">
<div class="media-left">
  <figure class="image is-64x64">
    <img :src="part.part.part_img_url" alt="Image">
  </figure>
</div>
<div class="media-content">
  <div class="content">
    <p>
      <strong>{{part.part.name}}</strong> <small>{{part.quantity}}</small>
      <br>
      {{part.color.name}}
    </p>
  </div>
    <div class="level-left">
      <a class="level-item">
        <span class="icon is-small"><i class="fas fa-heart"></i></span>
        <span class="likes">xx{{tweet.likes}}</span>
      </a>
    </div>
</div>
</article>
      </div>
      <div class="control has-icons-left has-icons-right">
        <input class="input is-small" placeholder="Tweet your reply..." />
        <span class="icon is-small is-left">
          <i class="fas fa-envelope"></i>
        </span>
      </div>
    </div>
  `,
  props: {
    part: Object
  },
name:part-component

});


import {part-component}

<template>
  <div class="container">
    <div class="hero" >
    <h1><span v-if="!setparts">Enter</span> Setnr</h1>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input is-fullwidth" type="text" v-model="setnr" v-on:keyup.enter="fetchSet" >
      </div>
      <div class="control">
        <button @click="fetchSet" class="button is-primary">Fetch</button>
      </div>
    </div>
    <div v-if="!setparts">Enter a valid setnr including -1, eg 6040-1 or 600-2 and press fetch.</div>
    </div>
    <div v-if="setinfo" class="section media-center">
    <img v-if="setinfo.set_img_url" :src=setinfo.set_img_url :alt=setinfo.name>
    </div>
    <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
    </section>
    <section v-else>
        <div v-if="loading">Loading...</div>

    <div v-if="setparts" class="listbox">
        <div v-if="setparts.count" @change="changeorder">
            <span>({{ (this.hascounter/setinfo.num_parts) | percent }} %)  {{setinfo.num_parts}} parts  </span>
            <span> order by: <select v-model="orderby">
            <option value="color">Color</option>
            <option value="partnr">Part number</option>
            <option value="category">Category</option>
            <option value="name">Name</option>
            </select></span>
        </div>
        <span>
        Show completed<input type=checkbox v-model="showcompleted">
        </span>
        <div v-for="(part, index) in this.thepartlist "
            v-bind:key="index"
            >
            <transition name="fade">
            <div class="box" v-if="part.quantity !== part.has || showcompleted">
            <!-- article  class="media" v-on:click="haveit(index)"  -->
            <article  class="media" :class="{active:interval}"  @click="haveit(index)">  
                <div class="media-left"> <img :src="part.part.part_img_url" class="image is-64x64"> </div>

                <div class="media-content">
                <span class="column has-text-weight-bold"><span v-if="part.is_spare===true">Spare </span>
Need: {{part.quantity}} <span @click="part.has=0">(has: {{part.has||0}})</span> {{part.color.name}}</span>
                <span class="column">{{part.part.name}} </span>
                </div>
                <div v-if="part.quantity<=part.has">OK</div>
            </article>
            </div>
            </transition>
        </div>
    </div>
    </section>

  </div>
</template>

<script>
//import gql from 'graphql-tag';
import axios from 'axios';
const access_token = '7eaf8b1d0e7fc358d3394b9d916b8f23';
import router from '../router'


export default {
  name: 'FindSet',
//  apollo: {
//    sets: gql`query {setnr}`
// },
  props: {
    setnrpath: String
  },
  data () {
    return {
        setnr: '',
        setinfo: null,
        setparts: null,
        hascounter: 0,
        setlist: [],
        loading: false,
        errored: false,
        orderby: 'color',
        showcompleted: 1,
        interval: false,
        count: 0,
        onlyone: 0
    }
  },
  filters: {
      percent(value) {
          return parseInt(value*100);
      }
  },
  computed: {
    thepartlist: function() {

        let vm = this.setparts.results;
        //if ( vm.setparts.result )
        //return vm.setparts.results.filter( res => { return res.quantity > 0 } );
        // sort by part_num
        //return vm.setparts.results.sort((a,b) => ( a.part.part_num > b.part.part_num ) ? 1:-1 );
        //if ( this.sortby === "partnr" ) {
        //    vm.sort((a,b) => ( a.part.part_num > b.part.part_num ) ? 1:-1 );
        //}
        //NAME
        //vm.sort((a,b) => ( a.part.name > b.part.name ) ? 1:-1 );
        //cat
        //vm.sort((a,b) => ( a.part.part_cat_id > b.part.part_cat_id ) ? 1:-1 );
        //vm.sort((a,b) => (a.quantity!=0) ? -1:0);// (( a.part.part_num === b.part.part_num ) ?1:-1));
        vm.reduce(function(res, el){
            if (el.quantity!=0) { res+=el; }
            return res;
        })

        //vm.sort((a,b) => (a.quantity> b.quantity) ? 1:-1);

       //vm.sort((a,b) => (a.quantity!=0) ? (( a.part.part_num === b.part.part_num ) ?1:-1): (( a.part.part_num > b.part.part_num ) ? 1:-1) );
        //vm.sort((a,b) => ( a.part.part_num > b.part.part_num ) ? 1: ( a.part.part_num === b.part.part_num ) ? ((a.quantity===0) ?1:-1 ):-1 );
/*
        //return vm.setparts.results.sort((a,b) => ( a.part.part_num > b.part.part_num ) ? 1: ( a.part.part_num === b.part.part_num ) ? ((a.quantity===0) ?1:-1 ):-1 );
        let thelist = vm.setparts.results;

        let haslist = [];
        for (let  i=0 ; i< thelist.length ; i++) {
            if ( thelist[i].quantity === 0 ) {
                let part = thelist.splice(i);
                haslist.push(part);
            }
        }
        /*thelist.forEach(funtion( item, index, array ){
                if ( item.quantity === 0 ) {
                    let part = array.splice(i);
                    haslist.push(part);
                }
        });*/
/*        console.log("DATA");
        console.log(haslist);
        return thelist;
*/
/* //Filter out the one we have
            return vm.filter(function(part) {
					return part.quantity != 0;
				});
                */
        return vm; //.setparts.results;
        //else
        //    return Object;
    }
  },
  mounted () {
      if (localStorage.getItem('setlist')) {
        try {
          this.setlist = JSON.parse(localStorage.getItem('setlist'));
        } catch(e) {
          localStorage.removeItem('setlist');
        }
      }

     // console.log(router);
    if (router.history.current.params.setnr) {
        this.setnr = router.history.current.params.setnr;
        this.fetchSet();
        return;
    }
    //if ( localStorage.setnr ) {
    //    this.setnr=localStorage.setnr;
    //}

  },

  methods:{
    tstart(){
      let intervalId = setInterval(function(){}, 1000); // will execute the function every 100ms.
      clearInterval(intervalId)
      this.start();
      this.count=-100
    },
    start(){
      if (this.count > 0 ) { this.count =0; }
      this.onlyone=1;
      if(!this.interval){
        this.interval = setInterval(() => this.count++, 30)	
      }
    },
    tstop(e){
      let intervalId = setInterval(function(){}, 1000); // will execute the function every 100ms.
      clearInterval(intervalId)
      this.stop(e);
    },
    stop(el){
      if ( this.onlyone === 1) { this.onlyone=0 }
     if ( this.count >  50 ) {
          this.count = 0
          //console.log(el);
          this.setparts.results[el].has = prompt("enter amount", this.setparts.results[el].has || 0); 
          var q= this.setparts.results[el];
          this.$set(this.setparts.results, el, q);      
    } else {
      //this.haveit(el)
    }
    clearInterval(this.interval)
     
      this.interval = false
    },
    fetchSet() {
        this.loading= true;
        this.errored = false;
        //localStorage.setnr=this.setnr;

        var re=/^[0-9]+-[0-9]$/;
        //if ( re.exec(localStorage.setnr) ) {
        if ( re.exec(this.setnr) ) {
            //this.setnr=this.setnr;
        } else {
            //localStorage.setnr=localStorage.setnr+"-1";
            //console.log(localStorage.setnr);
            this.setnr=this.setnr+"-1";
        }
        //if( ! this.setnr )
        this.setInfo();
        axios
            .get('https://rebrickable.com/api/v3/lego/sets/'+this.setnr+'/parts/?page_size=10000',  {
                headers: {
                    'Authorization': `key ${access_token}`
                    }
            })
            .then(response => (this.setparts = response.data ))
            .catch((error) => {
                this.setinfo=error
                this.errored = true
            }
            )
            .finally(() => {this.loading = false;
                            console.log(this.setparts);
             })
        this.hascounter=0;

    },
    changeorder() {
            console.log("Update some:"+this.orderby);
            if ( this.orderby === "partnr" ) {
                return this.thepartlist.sort((a,b) => ( a.part.part_num > b.part.part_num ) ? 1:-1 );
            }
            if ( this.orderby === "color" ) {
                return this.thepartlist.sort((a,b) => ( a.color.name > b.color.name ) ? 1:-1 );
            }
            if ( this.orderby === "category" ) {
                return this.thepartlist.sort((a,b) => ( a.part.part_cat_id > b.part.part_cat_id ) ? 1:-1 );
            }
            if ( this.orderby === "name" ) {
                return this.thepartlist.sort((a,b) => ( a.part.name > b.part.name ) ? 1:-1 );
            }
    },
    haveit( message ) {
/*
        if ( this.setparts.results[message].quantity <= 0) {
            this.setparts.results[message].quantity=0;
            return;
        }*/
        //this.hascounter++;
        //this.setparts.results[message].quantity--;
        if ( this.setparts.results[message].has ) {
            if ( this.setparts.results[message].has < this.setparts.results[message].quantity ) {
              this.setparts.results[message].has++;
               this.hascounter++;
            }
        } else {
            this.setparts.results[message].has=1;
             this.hascounter++;
        }
        var q= this.setparts.results[message];
        this.$set(this.setparts.results, message, q);
        console.log(this.setparts);
    },
    setInfo() {
        axios
            .get('https://rebrickable.com/api/v3/lego/sets/'+this.setnr,  {
                headers: {
                    'Authorization': `key ${access_token}`
                    }
            })
            .then(response => (this.setinfo = response.data ))
            .finally(() => {
                            console.log(this.setinfo);
                            this.setinfo.nr= this.setnr;
                            this.$store.commit('addset', this.setinfo ); // {nr: this.setnr, name: this.setinfo.name, this.setinfo});
             })
    },
    saveSets() {
      const parsed = JSON.stringify(this.setlist);
      localStorage.setItem('setlist', parsed);
    },
    finishedLast(arr) {
        let res=arr;
        console.log("filter");
        res.filter( res => { return res.quantity < 0 } );
        return res;
    }

    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.inputa {
  border-radius: 4px;
  font-size: 16px;
  height: 48px;
  padding-left: 5px;
  color: #333;
  border: 1px solid rgba(60, 60, 60, 0.26);
}

.box {
  transition: visibility 0s linear 0.7s, opacity 0.7s ease-in-out;
}

.box:active {
  border: #999999;
  border-block-color: #999999;
  transform: translateY(4px);
}


.fade-enter-active, {
   transition: opacity .5s;
}

.fade-leave-active {
  background-color: #42b983;
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>
